import type {
  BaseTaskApiModel,
  ClientTaskApiModel,
  CoachTaskApiModel,
} from '../../../api/task/types';

import {getEntityTypeById} from '../getEntityType';

export const isClientTask = (entity: any): entity is ClientTaskApiModel =>
  getEntityTypeById(entity?._id) === 'task';

export const isCoachTask = (entity: any): entity is CoachTaskApiModel =>
  getEntityTypeById(entity?._id) === 'coach_task';

export const isBaseTask = (entity: any): entity is BaseTaskApiModel =>
  getEntityTypeById(entity?._id) === 'base_task';

export const isClientOrCoachTask = (
  entity: any,
): entity is ClientTaskApiModel | CoachTaskApiModel =>
  isClientTask(entity) || isCoachTask(entity);
